import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "builder-estimator-summary" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "image-container" }
const _hoisted_4 = { class: "form-container" }
const _hoisted_5 = { class: "build-price-container" }
const _hoisted_6 = { class: "build-price-amount" }
const _hoisted_7 = { class: "summary-items-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["BuilderEstimatorSummarySidebar"], {
      "builder-logo": $setup.props.builderLogo,
      "user-selected-options": $setup.props.formData,
      "total-price": $props.totalPrice,
      "show-success-message": $props.showSuccessMessage,
      "is-loading": $setup.props.isLoading,
      onSelectPrev: $setup.onSelectPrev,
      onOnSubmit: $setup.onSubmit
    }, null, 8, ["builder-logo", "user-selected-options", "total-price", "show-success-message", "is-loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["CustomizeHouseSlider"], {
          sliderImages: $setup.userSelectionsToSliderImages,
          showArrows: true
        }, null, 8, ["sliderImages"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "design-title" }, "My Home Design", -1)),
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "build-price-label" }, "BUILD PRICE:", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString($props.totalPrice), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allSummaryItems, (item) => {
            return (_openBlock(), _createBlock($setup["BuilderEstimatorSummaryItem"], {
              key: item.id || item.title,
              title: item.title,
              value: item.value,
              price: item.price,
              imageUrl: item.imageUrl
            }, null, 8, ["title", "value", "price", "imageUrl"]))
          }), 128))
        ])
      ])
    ])
  ]))
}